// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  position: relative;
  overflow: hidden;
  font-family: 'Inter', sans-serif;
}

.login-background-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 800px;
  height: 800px;
  background: radial-gradient(circle, rgba(62, 142, 158, 0.15) 0%, transparent 70%);
  /* Brand color hint */
  filter: blur(100px);
  z-index: 1;
  opacity: 0.8;
}

.login-container {
  width: 100%;
  max-width: 420px;
  /* Slightly wider for breathing room */
  padding: 20px;
  position: relative;
  z-index: 10;
}

.login-card {
  background: rgba(255, 255, 255, 0.95);
  /* Slight transparency */
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  padding: 40px 35px;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow:
    0 20px 50px rgba(0, 0, 0, 0.1),
    0 10px 20px rgba(0, 0, 0, 0.05);
  /* Double shadow for depth */
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-height: 95vh;
  transition: transform 0.3s ease;
}

/* Main Logo */
.login-main-logo {
  width: auto;
  height: 140px;
  object-fit: contain;
  margin-bottom: 5px;
  filter: drop-shadow(0 10px 15px rgba(0, 0, 0, 0.1));
}

.login-illustration img {
  width: auto;
  height: 130px;
  object-fit: contain;
  margin-bottom: 20px;
  filter: drop-shadow(0 10px 15px rgba(0, 0, 0, 0.1));
  /* Pop the image */
}

/* Brand Section */
.login-brand-section {
  margin-bottom: 20px;
}

.brand-title {
  display: flex;
  justify-content: center;
  font-family: 'Poppins', sans-serif;
  font-size: 32px;
  font-weight: 800;
  margin: 0;
  margin-bottom: 6px;
  cursor: default;
}

.brand-title span {
  display: inline-block;
  color: #111;
  background: linear-gradient(to right, #000000 0%, #888888 50%, #000000 100%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  transition: transform 0.2s ease;

  /* Continuous Animation */
  animation: brand-shine 2s linear infinite;
  animation-play-state: running;
}

.brand-title span:hover {
  transform: translateY(-2px);
  /* Individual letter hop */
}

@keyframes brand-shine {
  0% {
    background-position: 0% center;
  }

  100% {
    background-position: 200% center;
  }
}

.brand-subtitle {
  font-family: 'Poppins', sans-serif;
  font-size: 10px;
  /* Small as requested */
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  margin: 0;
  letter-spacing: 3px;
}

/* Divider */
.login-divider {
  width: 60px;
  height: 3px;
  background: #f0f0f0;
  border-radius: 10px;
  margin: 15px 0 25px 0;
}

.login-header {
  margin-bottom: 20px;
}

.login-heading {
  font-size: 18px;
  font-weight: 700;
  color: #222;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin: 0;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.input-group {
  position: relative;
  width: 100%;
}

.input-group i {
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  font-size: 16px;
  pointer-events: none;
  transition: color 0.3s ease;
}

.login-input {
  width: 100%;
  background: #f8f9fa;
  border: 1px solid transparent;
  padding: 16px 20px 16px 50px;
  border-radius: 12px;
  color: #333;
  font-size: 15px;
  font-weight: 500;
  outline: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.login-input:focus {
  background: #fff;
  border-color: #333;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transform: translateY(-1px);
}

.login-input:focus+i {
  color: #111;
}

.login-submit-btn {
  background: linear-gradient(145deg, #2b2b2b, #000000);
  /* Subtle gradient */
  color: #ffffff;
  padding: 16px;
  border-radius: 12px;
  border: none;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  cursor: pointer;
  width: 100%;
  margin-top: 5px;
  transition: all 0.3s ease;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}

.login-submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.25);
}

.login-submit-btn:active {
  transform: translateY(0) scale(0.98);
}

.login-footer-links {
  margin-top: 18px;
}

.forgot-password {
  background: none;
  border: none;
  padding: 0;
  font-family: inherit;
  cursor: pointer;
  font-size: 13px;
  color: #777;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.forgot-password:hover {
  color: #111;
  text-decoration: none;
}

.login-footer {
  margin-top: 20px;
  text-align: center;
  font-size: 12px;
  color: #999;
}

.login-footer span {
  color: #222;
  font-weight: 700;
}

@keyframes directed-shine {
  0% {
    left: -150%;
  }

  100% {
    left: 150%;
  }
}

@media (max-width: 480px) {
  .login-card {
    padding: 20px;
    width: 95%;
  }

  .login-illustration img {
    height: 100px;
  }

  .brand-title {
    font-size: 20px;
  }

  .brand-subtitle {
    font-size: 0.55rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,iFAAiF;EACjF,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;EACxB,mCAA2B;UAA3B,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C;;mCAEiC;EACjC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,cAAc;AACd;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,4EAA4E;EAC5E,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,+BAA+B;;EAE/B,yBAAyB;EACzB,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');\n\n.login-wrapper {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #ffffff;\n  position: relative;\n  overflow: hidden;\n  font-family: 'Inter', sans-serif;\n}\n\n.login-background-glow {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 800px;\n  height: 800px;\n  background: radial-gradient(circle, rgba(62, 142, 158, 0.15) 0%, transparent 70%);\n  /* Brand color hint */\n  filter: blur(100px);\n  z-index: 1;\n  opacity: 0.8;\n}\n\n.login-container {\n  width: 100%;\n  max-width: 420px;\n  /* Slightly wider for breathing room */\n  padding: 20px;\n  position: relative;\n  z-index: 10;\n}\n\n.login-card {\n  background: rgba(255, 255, 255, 0.95);\n  /* Slight transparency */\n  backdrop-filter: blur(10px);\n  padding: 40px 35px;\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.8);\n  box-shadow:\n    0 20px 50px rgba(0, 0, 0, 0.1),\n    0 10px 20px rgba(0, 0, 0, 0.05);\n  /* Double shadow for depth */\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  max-height: 95vh;\n  transition: transform 0.3s ease;\n}\n\n/* Main Logo */\n.login-main-logo {\n  width: auto;\n  height: 140px;\n  object-fit: contain;\n  margin-bottom: 5px;\n  filter: drop-shadow(0 10px 15px rgba(0, 0, 0, 0.1));\n}\n\n.login-illustration img {\n  width: auto;\n  height: 130px;\n  object-fit: contain;\n  margin-bottom: 20px;\n  filter: drop-shadow(0 10px 15px rgba(0, 0, 0, 0.1));\n  /* Pop the image */\n}\n\n/* Brand Section */\n.login-brand-section {\n  margin-bottom: 20px;\n}\n\n.brand-title {\n  display: flex;\n  justify-content: center;\n  font-family: 'Poppins', sans-serif;\n  font-size: 32px;\n  font-weight: 800;\n  margin: 0;\n  margin-bottom: 6px;\n  cursor: default;\n}\n\n.brand-title span {\n  display: inline-block;\n  color: #111;\n  background: linear-gradient(to right, #000000 0%, #888888 50%, #000000 100%);\n  background-size: 200% auto;\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  transition: transform 0.2s ease;\n\n  /* Continuous Animation */\n  animation: brand-shine 2s linear infinite;\n  animation-play-state: running;\n}\n\n.brand-title span:hover {\n  transform: translateY(-2px);\n  /* Individual letter hop */\n}\n\n@keyframes brand-shine {\n  0% {\n    background-position: 0% center;\n  }\n\n  100% {\n    background-position: 200% center;\n  }\n}\n\n.brand-subtitle {\n  font-family: 'Poppins', sans-serif;\n  font-size: 10px;\n  /* Small as requested */\n  font-weight: 600;\n  color: #666;\n  text-transform: uppercase;\n  margin: 0;\n  letter-spacing: 3px;\n}\n\n/* Divider */\n.login-divider {\n  width: 60px;\n  height: 3px;\n  background: #f0f0f0;\n  border-radius: 10px;\n  margin: 15px 0 25px 0;\n}\n\n.login-header {\n  margin-bottom: 20px;\n}\n\n.login-heading {\n  font-size: 18px;\n  font-weight: 700;\n  color: #222;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  margin: 0;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n\n.input-group {\n  position: relative;\n  width: 100%;\n}\n\n.input-group i {\n  position: absolute;\n  left: 18px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #999;\n  font-size: 16px;\n  pointer-events: none;\n  transition: color 0.3s ease;\n}\n\n.login-input {\n  width: 100%;\n  background: #f8f9fa;\n  border: 1px solid transparent;\n  padding: 16px 20px 16px 50px;\n  border-radius: 12px;\n  color: #333;\n  font-size: 15px;\n  font-weight: 500;\n  outline: none;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.login-input:focus {\n  background: #fff;\n  border-color: #333;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);\n  transform: translateY(-1px);\n}\n\n.login-input:focus+i {\n  color: #111;\n}\n\n.login-submit-btn {\n  background: linear-gradient(145deg, #2b2b2b, #000000);\n  /* Subtle gradient */\n  color: #ffffff;\n  padding: 16px;\n  border-radius: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.2px;\n  cursor: pointer;\n  width: 100%;\n  margin-top: 5px;\n  transition: all 0.3s ease;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);\n}\n\n.login-submit-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.25);\n}\n\n.login-submit-btn:active {\n  transform: translateY(0) scale(0.98);\n}\n\n.login-footer-links {\n  margin-top: 18px;\n}\n\n.forgot-password {\n  background: none;\n  border: none;\n  padding: 0;\n  font-family: inherit;\n  cursor: pointer;\n  font-size: 13px;\n  color: #777;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.forgot-password:hover {\n  color: #111;\n  text-decoration: none;\n}\n\n.login-footer {\n  margin-top: 20px;\n  text-align: center;\n  font-size: 12px;\n  color: #999;\n}\n\n.login-footer span {\n  color: #222;\n  font-weight: 700;\n}\n\n@keyframes directed-shine {\n  0% {\n    left: -150%;\n  }\n\n  100% {\n    left: 150%;\n  }\n}\n\n@media (max-width: 480px) {\n  .login-card {\n    padding: 20px;\n    width: 95%;\n  }\n\n  .login-illustration img {\n    height: 100px;\n  }\n\n  .brand-title {\n    font-size: 20px;\n  }\n\n  .brand-subtitle {\n    font-size: 0.55rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
